// Open modal
jQuery( '.open-modal' ).on( 'click', function(e) {
    e.preventDefault();
    var id = jQuery( this ).attr( 'modal-id' );
    jQuery( '.modal#' + id ).addClass('show');
    jQuery( '.modal#' + id ).find('[data-slider="modalSlider"]').slick('setPosition');
} );
  
  // Close modal on x click
jQuery( '.modal-close' ).on( 'click', function() {
    var id = jQuery( this ).closest( '.modal' ).attr( 'id' );
    jQuery( '#' + id ).removeClass('show');
} );

jQuery(window).on("scroll resize load", function() {
  var headerHeight = jQuery('header').outerHeight();
  jQuery('.modal').css('padding-top', headerHeight);
});

jQuery(document).ready(function() {
  var headerHeight = jQuery('header').outerHeight();
  jQuery('.modal').css('padding-top', headerHeight);
});  

if (jQuery('[data-slider="modalSlider"]').length) {
  
  jQuery('[data-slider="modalSlider"]').each(function() {
    var modalSlider = jQuery(this);
    var modalSliderArrows = modalSlider.next('.arrows');
    modalSlider.slick({
      arrows: false,
      prevArrow: modalSliderArrows.find('.modal-slider-prev'),
      nextArrow: modalSliderArrows.find('.modal-slider-next'),
      draggable: true,
      dots: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      centerMode: true,
      centerPadding: '0',
      rows: 0,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            autoplay: true,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            speed: 300,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: false
          }
        }
      ]
    });
  });
}